import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Get available inventory for transfer
 * @param {Object} params - Query parameters
 * @param {number} params.productId - Product ID
 * @param {number} params.sourceStoreId - Source store ID
 * @returns {Promise<Object>} Product availability details
 */
export const getAvailableInventory = async (params) => {
  const queryParams = new URLSearchParams();
  if (params.productId) queryParams.append('productId', params.productId);
  if (params.sourceStoreId) queryParams.append('sourceStoreId', params.sourceStoreId);
  
  const response = await axiosInstance.get(`/inventory-transfer/available?${queryParams.toString()}`);
  return response.data;
};

/**
 * Create inventory transfer
 * @param {Object} transferData - Transfer data
 * @param {string} transferData.transferDate - Transfer date
 * @param {number} transferData.sourceStoreId - Source store ID
 * @param {number} transferData.destinationStoreId - Destination store ID
 * @param {string} transferData.transferReason - Transfer reason/notes
 * @param {Array} transferData.items - Array of transfer items
 * @returns {Promise<Object>} Created transfer response
 */
export const createTransfer = async (transferData) => {
  const response = await axiosInstance.post('/inventory-transfer/create', transferData);
  return response.data;
};

/**
 * Get transfer history with filters
 * @param {Object} params - Query parameters
 * @param {number} params.storeId - Filter by store (source or destination)
 * @param {string} params.startDate - Start date filter
 * @param {string} params.endDate - End date filter
 * @returns {Promise<Object>} Transfer history list
 */
export const getTransferHistory = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.storeId) queryParams.append('storeId', params.storeId);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  
  const response = await axiosInstance.get(`/inventory-transfer/history?${queryParams.toString()}`);
  return response.data;
};

/**
 * Get transfer by ID
 * @param {number} id - Transfer ID
 * @returns {Promise<Object>} Transfer details
 */
export const getTransferById = async (id) => {
  const response = await axiosInstance.get(`/inventory-transfer/${id}`);
  return response.data;
};

/**
 * Cancel transfer (if supported)
 * @param {number} id - Transfer ID
 * @returns {Promise<Object>} Cancel response
 */
export const cancelTransfer = async (id) => {
  const response = await axiosInstance.post(`/inventory-transfer/${id}/cancel`);
  return response.data;
};
